module.exports = __webpack_public_path__ + "img/mid-fi.3a899f01.svg";